/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Select, { Props } from 'react-select'
import makeAnimated from 'react-select/animated'
import cx from 'classnames'
import styles from '../../index.scss'

const animatedComponents = makeAnimated()

export interface IOSelect extends Props {
  className?: string
  title: string
}

const { colorPrimary } = styles

const style = {
  container: (base: any) => ({ ...base, flex: 4 }),

  control: (base: any) => ({
    ...base,
    border: `1px solid gray`,
    boxShadow: 'none',
    borderRadius: 0,
    '&:hover': {
      border: `1px solid ${colorPrimary}`,
    },
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected ? `${colorPrimary}` : base.backgroundColor,
    color: state.isSelected ? 'white' : base.color,
    fontSize: '12px',
    '&:hover': {
      backgroundColor: state.isSelected ? `${colorPrimary}` : `${colorPrimary}`,
      color: state.isSelected ? base.color : 'white',
    },
    ':active': {
      ...base[':active'],
      backgroundColor: state.isSelected ? `${colorPrimary}` : `${colorPrimary}`,
      color: 'white',
    },
  }),
}

const OSelect = function ({ className, title, ...props }: IOSelect) {
  return (
    <div className={cx(className, 'ocla-select')}>
      <div className='ocla-select__title'>{title}</div>
      <Select styles={style} {...props} components={animatedComponents} />
    </div>
  )
}

export default React.memo(OSelect)
